import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const TrailingSlashRedirect = ({ children }) => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // Vérifier si l'URL se termine par un slash et n'est pas la racine "/"
        if (location.pathname !== '/' && location.pathname.endsWith('/')) {
            // Supprimer le slash final et rediriger
            const newPath = location.pathname.slice(0, -1);
            navigate(newPath + location.search + location.hash, { replace: true });
        }
    }, [location, navigate]);

    return children;
};

export default TrailingSlashRedirect;
